import React, { useState } from "react";
import ScreenLoader from "../../../components/ScreenLoader";
import AddEditBetGameModal from "../../../components/Models/AddEditBetGameModal";
import moment from "moment";
import actions from "../../../redux/actions";
import * as RiIcons from "react-icons/ri";
import { isSuperAdmin } from "../../../utils";
const SMBookedGameTable = ({ data }) => {
  const [editFormData, setEditFormData] = useState({});
  const [loader, setLoader] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const handleEditClose = () => setShowEditModal(false);

  const handleCreateClose = () => setShowCreateModal(false);

  const updateListHandler = () => {
    console.log("Updating client list...");
  };

  // Validate if data is an array
  const isValidData = Array.isArray(data);
  const handleDelete = (itemData) => {
    const isConfirmed = window.confirm(
      "Do you really want to delete this item?",
      "Delete Confirmation",
    );
    if (isConfirmed) {
      debugger;
      actions.deleteSMbet(itemData.id);
      window.location.reload();
    }
  };
  return (
    <>
      {showCreateModal && (
        <AddEditBetGameModal
          mode="add"
          showModal={showCreateModal}
          handleModalClose={handleCreateClose}
          handleClientList={updateListHandler}
        />
      )}

      {showEditModal && (
        <AddEditBetGameModal
          mode="edit"
          showModal={showEditModal}
          handleModalClose={handleEditClose}
          handleClientList={updateListHandler}
          gameData={editFormData}
        />
      )}

      {loader ? (
        <ScreenLoader />
      ) : (
        <div className="card shadow mb-4">
          <div className="table-responsive">
            {isValidData ? (
              <table className="table table-bordered dataTable" width="100%">
                <thead>
                  <tr className="bg-gray-300">
                    <th>S.No.</th>
                    <th>User Name</th>
                    <th>Match Name</th>
                    <th>Bet No.</th>
                    <th>Amount</th>
                    <th>IP</th>
                    <th>Date</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((user, index) => (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "even" : "odd"}
                      >
                        <td>{index + 1}</td>
                        <td>{user.UserName}</td>
                        <td>{user.MatchName}</td>
                        <td>{user.betNo}</td>
                        <td>{user.Amount}</td>
                        <td>{user.IP_Address}</td>
                        <td>
                          {moment(user.CreatedOn).format("DD-MM-YYYY h:mm A")}
                        </td>
                        {isSuperAdmin() && (
                          <td>
                            <RiIcons.RiDeleteBinLine
                              onClick={() => handleDelete(user)}
                              style={{ fontSize: "15px" }}
                            />
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" style={{ textAlign: "center" }}>
                        No Data
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            ) : (
              <div
                style={{ textAlign: "center", padding: "20px", color: "red" }}
              >
                {typeof data === "string" ? data : "Invalid data received"}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SMBookedGameTable;
